import React from "react";
import { useToast } from "../contexts/ToastContext";

const ToastContainer: React.FC = () => {
  const { toasts, remove } = useToast();

  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-2 w-80 max-w-[90vw]">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`rounded-xl px-4 py-3 shadow-lg border text-sm flex items-start justify-between ${
            t.type === "success"
              ? "bg-green-50 border-green-200 text-green-800"
              : t.type === "error"
              ? "bg-red-50 border-red-200 text-red-800"
              : "bg-gray-50 border-gray-200 text-gray-800"
          }`}
        >
          <div className="pr-3">{t.message}</div>
          <button
            onClick={() => remove(t.id)}
            className="ml-2 text-gray-500 hover:text-gray-700"
            aria-label="Fermer"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
